import IFinalizaViagemDTO from '../entities/IFinalizaViagem'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IFinalizaViagem {
  execute(params: IFinalizaViagemDTO): Promise<boolean>
}

export default class FinalizaViagemImpl implements IFinalizaViagem {
  constructor(private readonly lotesRepository: ILoteRepository) {}

  public async execute(params: IFinalizaViagemDTO): Promise<boolean> {
    const { status } = await this.lotesRepository.finalizaViagem(params)
    if (status === 200) {
      return true
    }
    return false
  }
}
